import { configureStore } from "@reduxjs/toolkit";
import templateReducer from "./templateSlice.js";
import campaignReducer from "./Campaign/campaignSlice.js";
import ContactReducer from "./contacts/contactSlice.js";
import ReplyMaterialSlice from "./ReplyMaterial/ReplyMaterialSlice.js";
import keywordReducer from "./Keywords/keywordsSlice.js";
import chatbotsReducer from "./Chatbot/chatbotsSlice.js";
import chatReducer from "./chat/chatSlice.js";
import broadcastAnalyticsReducer from "./broadcastAnalytics/broadcastAnalyticsSlice.js";
import userManagementReducer from "./UserManagement/userSlice.js";
import whatsappReducer from "./WhatsApp/whatsappSlice.js";

export const store = configureStore({
  reducer: {
    templates: templateReducer,
    campaign: campaignReducer,
    contact: ContactReducer,
    replyMaterial: ReplyMaterialSlice,
    keywords: keywordReducer,
    chatbots: chatbotsReducer,
    chat: chatReducer,
    broadcastAnalytics: broadcastAnalyticsReducer,
    userManagement: userManagementReducer,
    whatsapp: whatsappReducer,
  },
});

export default store;
